import { axios } from '@pukka/auth';
import { constants } from '@pukka/common';

type UpdateOutletSubscription = {
  readonly isActive: boolean;
  readonly id?: number;
};

const { MOKA_GOAUTH_SERVICE } = constants;

const UPDATE_OUTLET_SUBSCRIPTION_URL = `${MOKA_GOAUTH_SERVICE}/api/v1/outlet/update_active_subcription`;

async function updateOutletSubscription(params: UpdateOutletSubscription) {
  const resp = await axios.put(UPDATE_OUTLET_SUBSCRIPTION_URL, params, { withCredentials: true });

  return resp.data;
}

export { UPDATE_OUTLET_SUBSCRIPTION_URL, updateOutletSubscription };
